/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

'use strict';

angular.module('webReader')
    .directive('sideNote', ["$window", "$parse", function($window, $parse) {
        return {
            scope: {
                sideNoteIndex: '='
            },
            restrict: 'E',
            replace: true,
            templateUrl: 'directives/sidenote/sidenote.view.html',
            controller: ["$scope", "NotesService", "DocumentService", "NotesModel", "$timeout", function($scope, NotesService, DocumentService, NotesModel, $timeout) {
                var scope = $scope;
                var noteObjectCollection;
                var position;

                scope.note = NotesService.getNote(scope.sideNoteIndex);
                // console.log(scope.note, 'test');
                noteObjectCollection = DocumentService.getSelectionObjectsCollection(scope.note);

                _.map(noteObjectCollection, function(el, i) {
                    $(el.element).addClass('content-mark');
                });

                position = $('[name=content-mark-' + noteObjectCollection[0].targetElement.uniqNavMark + ']').position();
                scope.top = (!!position) ? position.top : $(noteObjectCollection[0].element).position().top;

                DocumentService.subscribe.onDocScrollRequested(
                    function(params) {
                        position = $('[name=content-mark-' + noteObjectCollection[0].targetElement.uniqNavMark + ']').position();
                        scope.top = (!!position) ? position.top : $(noteObjectCollection[0].element).position().top;
                    }
                );

                scope.shortNoteClick = function(e) {
                    scope.fullView = !scope.fullView;
                    // console.log('enable', scope.top  / 2);    
                    e.preventDefault();
                    e.stopPropagation();
                };

                scope.deleteNote = function() {
                    NotesModel.removeNote(scope.note.uuid, scope.note);
                };

                scope.updateNoteText = function() {
                    NotesModel.updateNoteText(scope.note).catch(function(data) {
                        //if error, return text back
                        scope.note.note.text = scope.note.previousText;
                    });
                };

                scope.editMode = {
                    status: false,
                    text: '',
                    enable: function($event) {
                        var target = angular.element('textarea.edit-note')[0];
                        var self = this;

                        this.text = scope.note.note.text;
                        this.status = true;

                        $event.stopPropagation();
                        $event.preventDefault();
                        $timeout(function() {
                            self.taChange({ target: target });
                            target.focus();
                            DocumentService.changeSpinnerState(true, true);
                        }, 50);
                    },
                    apply: function() {
                        scope.note.previousText = scope.note.note.text;
                        scope.note.note.text = this.text;
                        this.status = false;
                        scope.updateNoteText();
                        DocumentService.changeSpinnerState(false, false);
                        scope.fullView = false;
                    },
                    cancel: function() {
                        this.status = false;
                        DocumentService.changeSpinnerState(false, false);
                        scope.fullView = false;
                    },
                    taChange: function(e) {
                        // e.target.style.height = '44px';
                        // e.target.style.height = (e.target.scrollHeight) + "px";
                        !!e.preventDefault && e.preventDefault();
                        !!e.stopPropagation && e.stopPropagation();
                    }
                };

                scope.setColor = function(newColor, e) {
                    scope.editColor = false;
                    scope.note.previousColor = scope.note.color.value;
                    scope.note.color.value = newColor;
                    console.log(newColor, 'color');
                    NotesModel.updateNoteColor(scope.note).then(function(data) {
                        if (!data || !data.uuid) {
                            throw 'Error while saving new color';
                        }
                    }).catch(function() {
                        scope.note.color.value = scope.note.previousColor;
                        NotesModel.updateNoteColor(scope.note);
                    });
                };


                _.map(noteObjectCollection, function(el, i) {
                    if (typeof scope.note.color === 'undefined') {
                        scope.note.color = {
                            value: 'yellow'
                        };
                    }
                    $('[name=content-mark-' + el.targetElement.uniqNavMark + ']')
                        .addClass('highlight-' + scope.note.color.value);
                });

                NotesModel.subscribe.onNoteColorUpdate(scope.note.uuid, function() {
                    _.map(noteObjectCollection, function(el, i) {
                        $('[name=content-mark-' + el.targetElement.uniqNavMark + ']')
                            .removeClass('highlight-pink highlight-green highlight-yellow highlight-blue yellow blue redm ')
                            .addClass('highlight-' + scope.note.color.value);
                    });
                });

                scope.$on('$destroy', function() {
                    _.each(noteObjectCollection, function(el, i) {
                        $('.content-mark[name=content-mark-' + el.targetElement.uniqNavMark).removeClass('content-mark').removeAttr('name');
                    });
                });
            }],
            link: function(scope, element, attrs) {
                //      var clickOutHandler = $parse(attrs.clickOut);
                angular.element($window).on('click', function(event) {
                    //    if (element[0].contains(event.target)) return;
                    scope.fullView = false;
                    scope.$apply();
                    scope.$applyAsync();
                    //    console.log('click', event.target);
                });
            }
        };
    }]);